<template>
  <div class="relative flex h-full w-full flex-col border border-gray-100">
    <div class="z-10 h-[36px] w-full flex-none">
      <ControlBar :enable-detail-link="enableDetailLink" :detail-page-url="detailPageUrl" />
    </div>

    <div ref="containerWrapper" class="h-0 flex-auto bg-gray-300 transition-[padding-left]">
      <Container>
        <Page
          :is-show-extracted-words="isShowExtractedWords"
          :is-force-show-highlight-blocks="isForceShowHighlightBlocks"
          :see-source-attribute-slug="seeSourceAttributeSlug"
        />
      </Container>

      <LoadingSpinner />
    </div>

    <div
      ref="thumbnailsDrawer"
      class="pointer-events-none absolute left-0 top-[36px] h-[calc(100%-56px)] w-64 overflow-hidden"
    >
      <div
        ref="thumbnailsWrapper"
        class="h-full w-full -translate-x-full overflow-auto bg-gray-600 px-6 py-4 transition-transform"
      >
        <div v-show="seeSourceAttributeSlug" class="mb-4">
          <label class="flex-line relative cursor-pointer">
            <input
              :checked="isOnlyShowAttributeSourcePages"
              autocomplete="off"
              class="toggle toggle-md toggle-primary-inverted"
              type="checkbox"
              @change="toggleIsOnlyShowAttributeSourcePages"
            />
            <span class="text-xs font-medium text-white ltr:ml-3 rtl:mr-3">{{
              $t("attributes_sidebar.attribute_source_pages_only")
            }}</span>
          </label>
        </div>

        <Thumbnails />
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from "vue"

import { useSetupImageViewer } from "../../composables/image-viewer/setupImageViewer"

import ControlBar from "../common/ControlBar.vue"
import Container from "../common/Container.vue"
import Page from "../common/Page.vue"
import Thumbnails from "../common/Thumbnails.vue"
import LoadingSpinner from "../common/LoadingSpinner.vue"

const props = defineProps({
  inputFileId: String,
  imageUrl: String,
  pageUrls: {
    type: Array,
    default: () => []
  },
  highlightBlockIds: Array,
  highlightBlockScores: Array,
  isShowExtractedWords: Boolean,
  isForceShowHighlightBlocks: Boolean,
  initialCenterRatio: Number,
  initialScale: Number,
  detailPageUrl: String,
  attributeSources: Array,
  seeSourceAttributeSlug: String,
  isEditable: Boolean,
  enableDetailLink: {
    type: Boolean,
    default: true
  }
})

const containerWrapper = ref(null)
const thumbnailsDrawer = ref(null)
const thumbnailsWrapper = ref(null)

const {
  viewerState: {
    isShowExtractedWords,
    isForceShowHighlightBlocks,
    detailPageUrl,
    seeSourceAttributeSlug,
    isOnlyShowAttributeSourcePages,
    toggleIsOnlyShowAttributeSourcePages
  },
  controlState: { isThumbnailsVisible }
} = useSetupImageViewer(props)

watch(
  isThumbnailsVisible,
  isThumbnailsVisible => {
    nextTick(() => {
      const containerWrapperElement = containerWrapper.value
      const thumbnailsDrawerElement = thumbnailsDrawer.value
      const thumbnailsWrapperElement = thumbnailsWrapper.value

      if (!containerWrapperElement || !thumbnailsDrawerElement || !thumbnailsWrapperElement) {
        return
      }

      if (isThumbnailsVisible) {
        containerWrapperElement.style.paddingLeft = "256px"
        thumbnailsDrawerElement.classList.remove("pointer-events-none")
        thumbnailsWrapperElement.classList.remove("-translate-x-full")
      } else {
        containerWrapperElement.style.paddingLeft = ""
        thumbnailsDrawerElement.classList.add("pointer-events-none")
        thumbnailsWrapperElement.classList.add("-translate-x-full")
      }
    })
  },
  { immediate: true }
)
</script>
